export const defaultCompare = <T>(a: T, b: T) => {
	if (a === b || (a instanceof Date && b instanceof Date && a.getTime() === b.getTime())) {
		return 0;
	}

	return a < b ? -1 : 1;
};
